module.exports = "<div class=\"dialog restore-dialog\">\n  <h2 mat-dialog-title>Restore previous unsaved {{ workflowType }}?</h2>\n  <mat-dialog-content>\n    <div class=\"icon-container\">\n      <mat-icon [@fadeIn]>insert_drive_file</mat-icon>\n    </div>\n  </mat-dialog-content>\n  <mat-dialog-actions>\n    <button mat-button [mat-dialog-close]=\"{restore: false}\">\n      Discard\n    </button>\n    <button mat-button [mat-dialog-close]=\"{restore: true}\">\n      Restore\n    </button>\n  </mat-dialog-actions>\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/transfers/restore-dialog.component.html
// module id = ./src/app/transfers/restore-dialog.component.html
// module chunks = main